<p
  class="txt-percian-gray text-xs text-center my-8"
  [ngClass]="cguClasses"
>
  Consultez notre
  <a href="#" class="underline font-semibold">Politique de confidentialité </a>
  au sujet de la gestion des vos données personnelles
</p>
